import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  MatButtonModule,
          MatCheckboxModule,
          MatToolbarModule,
          MatCardModule,
          MatListModule,
          MatIconModule,
          MatMenuModule,
          MatInputModule,
          MatFormFieldModule,
          MatSnackBarModule,
          MatSidenavModule,
          MatExpansionModule,
          MatStepperModule,
          MatSliderModule,
          MatProgressSpinnerModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatExpansionModule,
    MatStepperModule,
    MatSliderModule,
    MatProgressSpinnerModule
  ],
  exports: [
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatExpansionModule,
    MatStepperModule,
    MatSliderModule,
    MatProgressSpinnerModule
  ],
  declarations: []
})
export class MaterialModule { }



// WEBPACK FOOTER //
// ./src/app/common/material.module.ts